import { App } from "vue";
import pinia from "@/plugins/PiniaPlugin";

import {
    cptProductKey,
    dmiProductKey,
    dmtProductKey,
    mttProductKey,
    osProductKey,
    type ProductDefinition,
    psProductKey,
    sfProductKey,
    spProductKey,
    tamProductKey,
    tspProductKey
} from "@/types/products/product-definitions";

import { useCheckPointTrader } from "@/composables/products/check-point-trader";
import { useDarkMoneyIndicator } from "@/composables/products/dark-money-indicator";
import { useDeepMarketTrader } from "@/composables/products/deep-market-trader";
import { useMonthlyTrendTrader } from "@/composables/products/monthly-trend-trader";
import { useOptionsSoup } from "@/composables/products/options-soup";
import { useProfitSkimmer } from "@/composables/products/profit-skimmer";
import { useSectorFocus } from "@/composables/products/sector-focus";
import { useSectorProphets } from "@/composables/products/sector-prophets";
import { useTechnicalAnalysisMillionaire } from "@/composables/products/technical-analysis-millionaire";
import { useTrueSovereignProfits } from "@/composables/products/true-sovereign-profits";
import { useProductsStore } from "@/stores/Products";

const ProductContextsPlugin = {
    install( app: App< Element > ) {
        useProductsStore( pinia ).initializeAsync().then( () => {
            // Register the CheckPoint Trader context provider
            app.provide< () => ProductDefinition >( cptProductKey, useCheckPointTrader );
            // Register the Dark Money Indicator context provider
            app.provide< () => ProductDefinition >( dmiProductKey, useDarkMoneyIndicator );
            // Register the Deep Market Trader context provider
            app.provide< () => ProductDefinition >( dmtProductKey, useDeepMarketTrader );
            // Register the Monthly Trend Trader context provider
            app.provide< () => ProductDefinition >( mttProductKey, useMonthlyTrendTrader );
            // Register the Options Soup context provider
            app.provide< () => ProductDefinition >( osProductKey, useOptionsSoup );
            // Register the Profit Skimmer context provider
            app.provide< () => ProductDefinition >( psProductKey, useProfitSkimmer );
            // Register the Sector Focus context provider
            app.provide< () => ProductDefinition >( sfProductKey, useSectorFocus );
            // Register the Sector Prophets context provider
            app.provide< () => ProductDefinition >( spProductKey, useSectorProphets );
            // Register the Technical Analysis Millionaire context provider
            app.provide< () => ProductDefinition >( tamProductKey, useTechnicalAnalysisMillionaire );
            // Register the True Sovereign Profits context provider
            app.provide< () => ProductDefinition >( tspProductKey, useTrueSovereignProfits );
        } )
    }
}

export default ProductContextsPlugin;
